// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3B2Qv","image":"styles_image__2Vn_4"};